import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
}

export default function StickyHeader({ children, className = '' }: Props) {
  return (
    <div
      className={`sticky top-0 z-10 px-sp-4 py-1.5 text-xs font-semibold uppercase tracking-wider ${className}`}
      style={{
        backgroundColor: 'var(--tg-theme-secondary-bg-color)',
        color: 'var(--tg-theme-hint-color)',
      }}
    >
      {children}
    </div>
  )
}
